<template>
  <!-- NOTE (TEMPLATE) to show the researcher login page -->

  <div
    class="app animated fadeIn flex-row align-items-center resBack"
    v-if="pageLoaded"
  >
    <b-toast
      id="example-toast"
      title="شماره تلفن همراه و رمز عبور نادرست است"
      static
      no-auto-hide
      >شماره تلفن همراه و رمز عبور نادرست است</b-toast
    >

    <div class="container">
      <div>
        <BannerSlider :images="banners" :clickable="true" :type="'download'" />
      </div>
      <b-row class="justify-content-center">
        <h1 class="mb-2 mt-6 text-white" style="color: #fff">
          پژوهشگر گرامی، به سامانه تقسیم کار ملی خوش آمدید!
        </h1>

        <b-col md="8" class="px-0">
          <b-card-group>
            <b-card no-body class="login-card p-4 pb-2">
              <b-card-header v-if="!sendCodeClicked || !codeSent">
                <b-button @click="swapLoginMode()">{{
                  codeLogin
                    ? "ورود با تلفن همراه و رمز عبور"
                    : "ورود با کد یکبارمصرف"
                }}</b-button>
              </b-card-header>

              <b-card-body v-if="codeLogin">
                <p class="text-muted">
                  لطفا برای ورود به سیستم و دریافت رمز عبور یکبار مصرف از طریق
                  پیامک،
                  <b>تلفن همراه</b> خود را وارد کنید.
                </p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-user"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>

                  <masked-input
                    dir="ltr"
                    type="text"
                    mask="\0911 111 1111"
                    v-model="username"
                    class="form-control"
                    placeholder="09__ ___ ____"
                    :disabled="codeSent"
                    @keyup.enter.native="!busy && username ? sendCode() : ''"
                  />
                </b-input-group>
                <!-- <b-form-group>
                  <vue-recaptcha
                    v-if="!codeSent"
                    @verify="actCaptchaVerify"
                    :sitekey="sitekey"
                  >
                  </vue-recaptcha>
                </b-form-group> -->
                <input type="text" v-model="company" style="display: none" />
                <b-input-group class="mb-4" v-if="codeSent">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-lock"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    trim
                    type="number"
                    :no-wheel="true"
                    v-model="activationCode"
                    class="form-control"
                    placeholder="کد ارسالی"
                    autofocus
                    @keyup.enter.native="
                      !busy && activationCode ? gotoDashboard() : ''
                    "
                  />
                </b-input-group>
                <b-row>
                  <b-col cols="6">
                    <b-button
                      v-if="!codeSent"
                      type="submit"
                      variant="primary"
                      @click="sendCode()"
                      style="border: 0"
                      :disabled="!username"
                      class="btn-radius px-8 py-2"
                    >
                      <i class="icon-login"></i>ارسال کد فعالسازی
                    </b-button>

                    <b-button
                      v-if="codeSent"
                      type="submit"
                      variant="primary"
                      @click="gotoDashboard()"
                      style="border: 0"
                      :disabled="busy || !activationCode"
                      class="btn-radius px-8 py-2"
                    >
                      <i class="icon-login"></i>ورود </b-button
                    >&nbsp;
                    <b-button
                      v-if="codeSent"
                      type="submit"
                      variant="info"
                      @click="changeNumber()"
                      style="border: 0"
                      :disabled="busy"
                      class="btn-radius px-8 py-2"
                    >
                      <b-icon icon="arrow-counterclockwise"></b-icon>تغییر تلفن
                      همراه
                    </b-button>
                  </b-col>
                  <b-col cols="6" class="text-left">
                    <b-button
                      v-if="codeSent"
                      type="submit"
                      variant="info"
                      @click="resendCode()"
                      style="border: 0"
                      :disabled="sendAgainDisbaled"
                      class="btn-radius px-8 py-2"
                    >
                      <b-icon icon="arrow-counterclockwise"></b-icon>ارسال مجدد
                      کد
                      <span v-if="countdown != 0">{{
                        toHHMMSS(countdown)
                      }}</span>
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-body>
              <b-card-body v-else>
                <p class="text-muted">
                  لطفا شماره تلفن همراه و رمز عبور (پیشفرض شماره تلفن همراه) خود
                  را وارد کنید
                  <br />
                  <br />لطفا توجه داشته باشید که
                  <b
                    >برای فعالسازی ورود با رمز عبور، حداقل یک مرتبه ورود با کد
                    فعالسازی الزامی است</b
                  >.
                </p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-user"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>

                  <b-form-input
                    trim
                    type="text"
                    v-model="username"
                    class="form-control"
                    placeholder="شماره تلفن همراه"
                  />
                </b-input-group>
                <input type="text" v-model="company" style="display: none" />
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-key"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>

                  <b-form-input
                    trim
                    type="password"
                    v-model="password"
                    class="form-control"
                    placeholder="رمز عبور"
                    @keyup.enter.native="
                      !busyLogin && username && password && recaptcha
                        ? login()
                        : ''
                    "
                  />
                </b-input-group>
                <!-- <div>
                  <b-form-group>
                    <vue-recaptcha @verify="captchaVerify" :sitekey="sitekey">
                    </vue-recaptcha>
                  </b-form-group>
                </div> -->
                <b-row>
                  <b-col cols="6">
                    <b-button
                      type="submit"
                      variant="primary"
                      @click="login()"
                      style="border: 0"
                      :disabled="busyLogin || !username || !password"
                      class="btn-radius px-8 py-2"
                    >
                      <i class="icon-login"></i>ورود
                    </b-button>
                  </b-col>
                  <b-col cols="6" class="text-left"></b-col>
                </b-row>
              </b-card-body>
              <div>
                <b-row></b-row>
              </div>
            </b-card>
          </b-card-group>
          <b-row class="justify-content-center mt-5">
            <v-btn
              color="indigo lighten-2"
              @click="goTo('admin')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود مدیر
            </v-btn>
            <v-btn
              color="red darken-3"
              @click="goTo('ref')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود داور
            </v-btn>
            <!-- <v-btn
              color="deep-orange lighten-1"
              @click="goTo('accelerator')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود شتاب‌دهنده
            </v-btn> -->
            <!-- <v-btn
              color="indigo"
              @click="goTo('company')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود شرکت
            </v-btn> -->
            <v-btn
              color="teal"
              @click="goTo('uni')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود دانشگاه
            </v-btn>
          </b-row>
          <hr class="mt-6" />
          <b-row class="justify-content-center mt-3">
            <v-btn
              color="blue darken-1"
              to="/map"
              class="m-1 white--text btn-radius"
              height="42"
              elevation="0"
            >
              <v-icon class="me-1">mdi-map</v-icon>نقشه تعاملی زیست فناوری
            </v-btn>
            <v-btn
              color="yellow darken-1"
              class="m-1 black--text btn-radius"
              height="42"
              elevation="0"
              @click="faqDialog = true"
            >
              <v-icon class="me-1">mdi-frequently-asked-questions</v-icon>سوالات
              متداول
            </v-btn>
            <v-btn
              color="orange darken-1"
              href="https://api.biodcportal.com/setad/public/طرح%20تقسیم%20کار%20ملی%20زیست%20فناوری.pdf"
              class="m-1 white--text btn-radius"
              height="42"
              elevation="0"
            >
              راهنمای آشنایی با طرح تقسیم کار ملی زیست فناوری
            </v-btn>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <ChangeLog />
    <FaqDialogue :faq-dialog.sync="faqDialog" />
  </div>
</template>

<script>
import MaskedInput from "../../node_modules/vue-masked-input";
import VueRecaptcha from "vue-recaptcha";
import md5 from "js-md5";
import utilities from "../mixins/utilities";
import createHumanVerification from "../mixins/humanVerification";
import BannerSlider from "../components/BannerSlider.vue";
const ChangeLog = () => import("../components/ChangeLog");
const FaqDialogue = () => import("../components/FaqDialogue");
export default {
  components: {
    MaskedInput,
    VueRecaptcha,
    ChangeLog,
    FaqDialogue,
    BannerSlider,
  },
  mixins: [utilities],
  data() {
    return {
      name: "Login",
      username: "",
      password: "",
      recaptcha: null,
      actCaptcha: null,
      activationCode: "",
      busy: false,
      busyLogin: false,

      codeSent: false,
      countdown: 0,
      timesup: true,
      codeLogin: true,
      sendCodeClicked: false,
      countdownGone: false,

      pageLoaded: false,
      faqDialog: false,

      humanVerifier: null,
      company: null,
      banners: [],
    };
  },
  watch: {
    codeSent: function (val, oldVal) {
      // NOTE (w-codeSent) to give the code again after 60 second
      this.countdown = 60;

      if (val == true) {
        this.sendAgainDisbaled = true;
        this.countDownTimer();
      }
    },
    countdown: function (val, oldVal) {
      // NOTE (w-countdown) to countdown for sending code again
      if (val == 0) {
        this.sendAgainDisbaled = false;
      } else {
        this.sendAgainDisbaled = true;
      }
    },
  },
  computed: {
    // newTimer: new Date(),
  },
  methods: {
    // NOTE geting captcha code when verified
    goTo(role) {
      if (role == "admin") {
        this.$router.push("/adminlogin");
      } else if (role == "ref") {
        this.$router.push("/reflogin");
      } else if (role == "uni") {
        this.$router.push("/unilogin");
      } else if (role == "company") {
        this.$router.push("/companyLogin");
      } else if (role == "accelerator") {
        this.$router.push("/acceleratorLogin");
      }
    },
    captchaVerify(response) {
      this.recaptcha = response;
    },
    actCaptchaVerify(response) {
      this.actCaptcha = response;
    },
    swapLoginMode() {
      this.username = "";
      this.codeLogin = !this.codeLogin;
    },
    toHHMMSS(value) {
      // NOTE (m-toHHMMSS) determine the order of hours, minutes and seconds
      var sec_num = parseInt(value, 10); // don't forget the second param
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - hours * 3600) / 60);
      var seconds = sec_num - hours * 3600 - minutes * 60;

      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      return minutes + ":" + seconds;
    },
    countDownTimer() {
      //NOTE (m-countDownTimer) to start counting down after 1 second
      if (this.countdown > 0) {
        setTimeout(() => {
          this.countdown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    changeNumber() {
      // NOTE (m-changeNumber) to change the number
      this.countdown = 0;
      this.codeSent = false;
    },
    resendCode() {
      this.countdownGone = false;
      this.sendCode();
    },
    async sendCode() {
      this.sendCodeClicked = true;
      this.username = this.username.split(" ").join("");
      // NOTE (m-sendCode) to send the code
      this.codeSent = false;
      this.busy = true;
      if (this.company)
        return this.toast(
          "شما ربات تشخیص داده شدید. دوباره تلاش نمایید.",
          "error"
        );
      const token = await this.humanVerifier.executeHumanCheck("login");

      this.$http
        .post(this.baseUrl + "/setad/authentication/recaptcahLogin", {
          mobile: this.username,
          // captcha: this.actCaptcha,
          humanToken: token,
        })
        .then(() => {
          this.countdown = 60;
          this.codeSent = true;
          this.busy = false;
          this.humanVerifier.destroy();
          this.humanVerifier.init();
        })
        .catch((err) => {
          this.humanVerifier.destroy();
          this.humanVerifier.init();
          this.actCaptcha = null;
          console.log(err);
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },

    async gotoDashboard() {
      // NOTE (m-gotoDashboard) to go to the dashboard
      this.busy = true;
      if (this.company)
        return this.toast(
          "شما ربات تشخیص داده شدید. دوباره تلاش نمایید.",
          "error"
        );
      const token = await this.humanVerifier.executeHumanCheck("login");
      this.$http
        .post(this.baseUrl + "/setad/authentication/entrance", {
          mobile: this.username,
          activationcode: this.activationCode,
          humanToken: token,
        })
        .then((res) => {
          if (res.status == 200) {
            localStorage.setItem("userId", res.data.token);

            localStorage.setItem("username", res.data.name);
            localStorage.setItem("role", "researcher");
            this.$route.query.return
              ? this.$router.push(this.$route.query.return)
              : this.$router.push("/researcher/dashboard");
          } else {
            this.busy = false;
            const title = (
              <div>
                <h5>!خطا</h5>
                <span>خطایی رخ داده است. مجددا امتحان کنید</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.busy = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },

    async login() {
      // NOTE (m-login) login using username and password
      this.busyLogin = true;
      if (this.company)
        return this.toast(
          "شما ربات تشخیص داده شدید. دوباره تلاش نمایید.",
          "error"
        );
      const token = await this.humanVerifier.executeHumanCheck("login");
      this.$http
        .post(this.baseUrl + "/setad/authentication/recaptcahLogin", {
          mobile: this.username,
          password: md5(this.password),
          // NOTE sending captcha code to backend
          // captcha: this.recaptcha,
          humanToken: token,
        })
        .then((res) => {
          if (res.status == 200) {
            localStorage.clear();
            localStorage.setItem("userId", res.data.token);

            localStorage.setItem("username", res.data.name);
            localStorage.setItem("role", "researcher");
            this.$route.query.return
              ? this.$router.push(this.$route.query.return)
              : this.$router.push("/researcher/dashboard");
            this.busyLogin = false;
          } else {
            this.humanVerifier.destroy();
            this.humanVerifier.init();
            this.recaptcha = null;
            this.busyLogin = false;
            const title = (
              <div>
                <h5>!خطا</h5>
                <span>خطایی رخ داده است. مجددا امتحان کنید</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.humanVerifier.destroy();
          this.humanVerifier.init();
          this.recaptcha = null;
          console.log(err);
          this.toast(err.response.data, "error");
          this.busyLogin = false;
        });
    },
    getBannersData() {
      this.isBusy = true;
      this.$http
        .get(this.baseUrl + "/setad/authentication/banners/")
        .then((res) => {
          this.banners = res.data;
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
  },
  created() {
    this.humanVerifier = createHumanVerification();
  },
  beforeDestroy() {
    this.humanVerifier.destroy();
  },
  mounted() {
    this.$http
      .post(this.baseUrl + "/setad/authentication/isSystemUp")
      .then((res) => {
        if (res.data) this.pageLoaded = true;
        else this.$router.push("/comingSoon");
      })
      .catch((err) => {
        this.$router.push("/comingSoon");
      });
    this.humanVerifier.init();
    this.getBannersData();
  },
};
</script>
<style scoped>
.resBack {
  background-image: url("../assets/images/resBack.png");
  background-size: cover;
}
</style>
